// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"583":"d25c10ed","907":"fb3c9c53"}[chunkId] + ".chunk.js";
};